import { DEFAULT_USER_PREFERENCES } from './constants';
import { UserPreferenceKeyValue } from './types';

/**
 * @description A switch for each user preference to patch
 *
 * Example:
 * user preference name: distributionStrategy
 * previously either "DISTANCE" or "TIME"
 * -> now the correct number, 0.1 for time and 1.0 for distance.
 */

// eslint-disable-next-line no-unused-vars
function patchPreferences(_item: UserPreferenceKeyValue) {
  return undefined;
}

/**
 * @description serves to patch outdated types of userPreferences which name has stayed but type of value has changed.
 */
export const patchUserPreferencesWithOutdatedTypes = (
  userPreferences: UserPreferenceKeyValue[],
) => {
  const patched: typeof userPreferences = [];
  userPreferences.forEach((item) => {
    const patchedValue = patchPreferences(item);
    const defaultValue = DEFAULT_USER_PREFERENCES[item.name];

    if (patchedValue !== undefined) {
      patched.push({ name: item.name, value: patchedValue } as typeof item);
      return;
    }

    if (typeof item.value !== typeof defaultValue) {
      patched.push({ name: item.name, value: defaultValue } as typeof item);
      return;
    }

    patched.push(item);
  });

  return patched;
};
